import React from 'react';

export const WaveDivider: React.FC<{ color1: string; color2: string }> = ({ color1, color2 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="16"
      viewBox="0 0 375 16"
      preserveAspectRatio="none"
      style={{ transform: 'translateY(10px)' }}
    >
      <path
        fill={color1}
        d="M187.5 5.44c-47.833 0-71.077 8.32-133.594 8.32C30.413 13.76 0 9.717 0 9.717v4.793S34.412 16 53.906 16c69.618 0 81.484-3.853 133.594-3.853s63.976 3.852 133.594 3.852C340.588 16 375 14.511 375 14.511V9.718s-30.413 4.041-53.906 4.041c-62.517 0-85.761-8.32-133.594-8.32z"
      ></path>
      <path
        fill={color2}
        d="M0 9.718s30.413 4.042 53.906 4.042c62.517 0 85.761-8.32 133.594-8.32s71.077 8.32 133.594 8.32C344.587 13.76 375 9.718 375 9.718V0H0v9.718z"
      ></path>
    </svg>
  );
};
